import { render, staticRenderFns } from "./move.vue?vue&type=template&id=50e301d2&scoped=true"
import script from "./move.vue?vue&type=script&lang=js"
export * from "./move.vue?vue&type=script&lang=js"
import style0 from "./move.vue?vue&type=style&index=0&id=50e301d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e301d2",
  null
  
)

export default component.exports